import styled from '@emotion/styled'

import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateHeader from '@/components/templates/TemplateHeader'
import TemplateHero from '@/components/templates/TemplateHero'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  background-color: white;
  width: 100%;
  height: 80px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 16px;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
`

Layout.Hero = styled(TemplateHero)`
  width: 100%;
  color: red;
  padding-bottom: 2em;
`

Layout.HeroContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
  min-height: calc(var(--preview-height) - 2em - 80px);
  max-height: calc(var(--preview-height) - 2em - 80px);
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-direction: column;
  flex-wrap: wrap;
  margin: auto 0; 
  padding-right: 10px;
`

Layout.Title = styled.h1`
  font-size: 4rem;
  font-weight: 700;
  text-transform: uppercase;
`
Layout.Subtitle = styled.p`
  margin-top: 1em;
  font-size: 22px;
`
Layout.CTA = styled(TemplateButton)`
  width: fit-content;
  font-size: 18px;
  font-weight: 700;
  padding: 12px 35px;
  margin-top: 2em;
`
Layout.HeroImageContainer = styled.div`
  overflow: hidden;
  border-radius: 0 0 100px 0;
  flex-basis: 50%;
`
export default Layout
